import dayjs from "dayjs";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import { NotificationService } from "@/services";
export default {
  name: "notifications",
  components: {},
  props: [],
  filters: {
    formatDate(date) {
      return dayjs(date).format("HH:mm YYYY/MM/DD");
    }
  },
  data() {
    return {
      offsetTop: 0,
      page: 1,
      drawer: false,
      editState: false,
      showDetail: false,
      moreBtnStatus: false,
      endOfNotifications: false,
      selected: []
    };
  },
  computed: {
    ...mapGetters({
      notificationDrawer: types.GET_NAVIGATIONS_DRAWER,
      notifications: types.notifications.getters.GET_NOTIFICATIONS
    }),
    getNotifications() {
      if (Object.entries(this.notifications).length > 0) {
        return this.notifications;
      }
    },
    drawerState: {
      get() {
        return this.notificationDrawer;
      },
      set(val) {
        this.notificationDrawerAction(val);
      }
    }
  },
  mounted() {
    this.getNotificationsFunc();
  },
  methods: {
    ...mapActions({
      setNotifications: types.notifications.actions.ACTION_NOTIFICATIONS,
      setPerPageNotifications:
        types.notifications.actions.ACTION_ADD_NOTIFICATIONS,
      notificationDrawerAction: types.ACTION_NAVIGATIONS_DRAWER
    }),
    notificationDrawerFunc() {
      this.notificationDrawerAction(!this.notificationDrawer);
    },
    getNotificationsFunc() {
      NotificationService.getNotifications().then(response => {
        this.setNotifications(response.data);
      });
    },
    getNotificationsPerPageFunc(page) {
      this.moreBtnStatus = true;
      NotificationService.getNotificationsPerPage(page)
        .then(response => {
          this.setPerPageNotifications(response.data);
        })
        .finally(() => (this.moreBtnStatus = false));
    },
    readAllNotificationsFunc() {
      NotificationService.readAllNotifications().then(() => {
        this.getNotificationsFunc();
        this.editState = false;
      });
    },
    showDetails(item) {
      this.showDetail = true;
      this.detailContent = item;
      NotificationService.readOneNotifications(item.id).then(() => {
        this.getNotificationsFunc();
      });
    }
  }
};
